import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { userAtom } from '../../../atoms/Atoms';
import useImpersonation from '../../../hooks/useImpersonation';

// Persistent banner shown while a SuperAdmin is acting as another user, with a
// one-click control to restore the original session.
function ImpersonationBanner() {
  const { t } = useTranslation();
  const { isImpersonating, stopImpersonation } = useImpersonation();
  const user = useRecoilValue(userAtom);

  if (!isImpersonating) return null;

  const name = user ? (user.completeName || `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email) : '';

  return (
    <div
      className="fixed w-full bg-red-600 text-white p-2 text-sm text-center flex items-center justify-center gap-2 shadow-md"
      style={{ zIndex: 1000 }}
    >
      <FontAwesomeIcon icon={faUserSecret} />
      <span>
        {t('impersonating_as')} <span className="font-bold">{name}</span>
      </span>
      <button
        type="button"
        onClick={stopImpersonation}
        className="underline font-semibold outline-none focus:outline-none"
      >
        {t('stop_impersonating')}
      </button>
    </div>
  );
}

export default ImpersonationBanner;
